/**
 * lucide-react v0.292.0 - ISC
 */
import createLucideIcon from '../createLucideIcon.js';
var Shield = createLucideIcon("Shield", [["path", {
  d: "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10",
  key: "1irkt0"
}]]);
export { Shield as default };